import { LayoutProps } from "react-admin";
import { HMLayout } from "./HMLayout";
import { useNavigate } from "react-router-dom";
import AppBar from "./AppBar";
import Menu from "./Menu";

export default (props: LayoutProps) => {
  const navigate = useNavigate();
  // const auth = localStorage.getItem("auth");
  // if (!auth) {
  const username = localStorage.getItem("username");
  if (!username) {
    navigate("/login");
  }
  return <HMLayout {...(props as any)} appBar={AppBar} menu={Menu} />;
};
